const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @commons
const { PopoverMenu } = require('commonsComponents/popoverMenu');
const MarketableOperationOKButton = require('components/broker/commons/marketableOperationOKButton/marketableOperationOKButton');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { taggingEventHandled } = require('utilities/taggingEventHandled');

// @actions
const BrokerPensionPlanContributionActions = require('actions/brokerPensionPlanContribution');

class BrokerFundContributionButton extends React.Component {
    constructor(props) {
        super(props);
        this.handleExtraordinaryContribution = this.handleExtraordinaryContribution.bind(this);
        this.handlePeriodicContribution = this.handlePeriodicContribution.bind(this);
    }

    handleExtraordinaryContribution() {
        const { history, onClick, fundId, secId, contractNumber, productName, pageName } = this.props;

        if (onClick) {
            onClick(contractNumber);
            taggingEventHandled(pageName, 'actionButtonMenu', productName, 'extraordinary' );
            history.push(`/myprofile/broker/buyInvestmentFunds/${secId}/${fundId}`);
        }
    }

    handlePeriodicContribution() {
        const { history, onClick, fundId, secId, contractNumber, productName, pageName } = this.props;
        if (onClick) {
            onClick(contractNumber);
            taggingEventHandled(pageName, 'actionButtonMenu', productName, 'periodic' );
            history.push(`/myprofile/broker/fundsPeriodicContribution/${secId}/${fundId}`);
        }
    }

    render() {
        const targetElement = (
            <MarketableOperationOKButton modifier="secondary" size="compact" disabled={this.props.disabled}>
                <div className="broker-products-table-row__buy-button">
                    <FormattedText value="broker-myInvestmentsSuscribeLink"/>
                </div>
            </MarketableOperationOKButton>
        );

        const options = [
            {
                text: formatText('broker-myInvestmentsFundExtraordinaryContributionButton'),
                handleClick: () => this.handleExtraordinaryContribution()
            },
            {
                text: formatText('broker-myInvestmentsFundPeriodicContributionButton'),
                handleClick: () => this.handlePeriodicContribution()
            }
        ];

        return (
            <PopoverMenu target={targetElement} items={options} placement="bottomRight" />
        );
    }
}

BrokerFundContributionButton.defaultProps = {
    disabled: false
}

BrokerFundContributionButton.propTypes = {
    history: PropTypes.object.isRequired,
    secId: PropTypes.string.isRequired,
    fundId: PropTypes.string.isRequired,
    contractNumber: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    finalType: PropTypes.string,
    productName: PropTypes.string,
    pageName: PropTypes.string
};

module.exports.constructor = BrokerFundContributionButton;
module.exports.BrokerFundContributionButton = connect(null, {
    onClick: BrokerPensionPlanContributionActions.setContractNumber
})(withRouter(BrokerFundContributionButton));